import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box
} from '@mui/material';

interface ThankYouDialogProps {
  open: boolean;
  onClose: () => void;
}

const ThankYouDialog: React.FC<ThankYouDialogProps> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          padding: 3,
          minWidth: 300,
          textAlign: 'center'
        }
      }}
    >
      <DialogContent>
        <Typography variant="h6" fontWeight="bold" color="#098963" gutterBottom>
          Thank you! <br />
          Your information <br /> has been recorded.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          One of our representatives will <br /> reach out to you within 24 hours.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', paddingBottom: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: '#098963',
            borderRadius: 2,
            paddingX: 5,
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#056e4e',
            }
          }}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ThankYouDialog;
